import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Homepage from './pages/user/Homepage';
import About from './pages/user/About';
import Admission from './pages/user/Admission';
import StudentLife from './pages/user/StudentLife';
import Blog from './pages/user/Blog';
import BlogDetail from './pages/user/BlogDetail';
import ICHarmony from './pages/user/ICHarmony';
// Add these new imports for admin routes
import Login from './pages/admin/Login';
import Dashboard from './pages/admin/Dashboard';
import PostForm from './pages/admin/PostForm';
import ProtectedRoute from './components/ProtectedRoute';
import { Analytics } from '@vercel/analytics/react';

function App() {
    return (
        <HelmetProvider>
            <Router>
                <Analytics />
                <Routes>
                    {/* Public Routes */}
                    <Route path="/" element={<Homepage />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/admission" element={<Admission />} />
                    <Route path="/student-life" element={<StudentLife />} />
                    <Route path="/blog" element={<Blog />} />
                    <Route path="/blog/:slug" element={<BlogDetail />} />
                    <Route path="/icharmony" element={<ICHarmony />} />
                    
                    {/* Admin Routes */}
                    <Route path="/admin/login" element={<Login />} />
                    <Route path="/admin/dashboard" element={
                        <ProtectedRoute>
                            <Dashboard />
                        </ProtectedRoute>
                    } />
                    <Route path="/admin/posts/new" element={
                        <ProtectedRoute>
                            <PostForm />
                        </ProtectedRoute>
                    } />
                    <Route path="/admin/posts/edit/:id" element={
                        <ProtectedRoute>
                            <PostForm />
                        </ProtectedRoute>
                    } />
                </Routes>
            </Router>
        </HelmetProvider>
    );
}

export default App;